import React from "react";
import PropTypes from "prop-types";
import AgeSelector from "./AgeSelector";
import styles from "./BookingForm.scss";
import classnames from "classnames";
import { CHILDREN_COUNT_FIELD } from "./constants";
import { defineMessages, FormattedMessage } from "react-intl";

const msgs = defineMessages({
  guestsPerRoom: {
    id: "booking_form.occupants_list.guestsPerRoom",
    description: "Guests per room",
    defaultMessage: "Guests per room",
  },
  apply: {
    id: "booking_form.occupants_list.apply",
    description: "Apply",
    defaultMessage: "Apply",
  },
});

function OccupantsList({ ...props }) {
  const {
    enabledSelectors,
    ageRanges,
    fields,
    selectorsRange,
    childrenCount,
    guestAges,
    childrenAgeRange,
    onAgeSelectorChange,
    fullWidth,
  } = props;

  return (
    <div
      className={classnames(
        "wbkv9-OccupantsList-OccupantTypeWrapper",
        styles.occupantTypeWrapper,
        fields[CHILDREN_COUNT_FIELD] && styles.hasAgeSelector,
        childrenCount > 0 && styles.showingAgeSelector
      )}>
      <div className={classnames("wbkv9-guestsPerAccommodation", styles.guestsPerAccommodation)}>
        <FormattedMessage {...msgs.guestsPerRoom} />
      </div>
      <div
        className={classnames(
          "wbkv9-OccupantsList-OccupantAndAgeWrapper",
          styles.occupantAndAgeWrapper
        )}>
        <AgeSelector
          enabledSelectors={enabledSelectors}
          ageRanges={ageRanges}
          fields={fields}
          initialChildrenCount={childrenCount}
          initialGuestAges={guestAges}
          selectorsRange={selectorsRange}
          childrenAgeRange={childrenAgeRange}
          onChange={onAgeSelectorChange}
          fullWidth={fullWidth}
        />
      </div>
      <div className={classnames("wbkv9-OccupantsList-ApplyButton", styles.applyButton)}>
        <button type="submit">
          <FormattedMessage {...msgs.apply} />
        </button>
      </div>
    </div>
  );
}

OccupantsList.propTypes = {
  enabledSelectors: PropTypes.array,
  ageRanges: PropTypes.object,
  fullWidth: PropTypes.bool,
  fields: PropTypes.object,
  selectorsRange: PropTypes.object,
  childrenAgeRange: PropTypes.object,
  childrenCount: PropTypes.number,
  guestAges: PropTypes.array,
  onAgeSelectorChange: PropTypes.func,
};

export default OccupantsList;
